
import React, { useContext, useState } from 'react';
import { AppContext } from "../util/AppContext";
import { Link } from 'react-router-dom';
import { getConfigValue, isBatchPrintEnabledForAnyProduct } from "../util/getConfigValue";
import Dropdown from 'react-bootstrap/Dropdown';
import ExportReportDataModal from './UtilizationReportingDashboard/ExportReportDataModal';
import { focusTypeName } from '../util/constants';
import { isTerritoryStepSkipped } from '../util/salesAidNavigation';
import PropTypes from 'prop-types';

PageContextMenu.propTypes = {
    includeExportOption: PropTypes.bool,
    forceShowSalesAidOption: PropTypes.bool
};

function PageContextMenu({ includeExportOption, forceShowSalesAidOption }) {
    const [appState, setAppState] = useContext(AppContext);
    const isExportDataEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Export?.Enabled, appState)?.Value === 'true' || false;
    const batchPrintEnabled = isBatchPrintEnabledForAnyProduct(appState);
    const salesAidGenerationEnabled = getConfigValue(appState?.config?.Sellsheet?.Generation?.Enabled, appState)?.Value === 'true' || false;
    const salesAidGenerationHomePageEnabled = getConfigValue(appState?.config?.Sellsheet?.Generation?.DisplayOptionOnHomePage?.Enabled, appState)?.Value === 'true' || false;
    const [showExportDataModal, setShowExportDataModal] = useState(false);
    function handleExportDataModalClick(event) {
        setShowExportDataModal(true);
    }

    function setFocus(focus) {
        if (!appState?.bypassTerritorySelection) {
            setAppState({
                ...appState,
                ...({
                    market: {},
                    territory: {}
                }),
                focus: focus,
                prescriber: {},
                products: [],
                currentProduct: "",
                plans: [],
                category: "",
                mainMessage: "",
            });
        } else {
            setAppState({
                ...appState,
                focus: focus,
                prescriber: {},
                products: [],
                currentProduct: "",
                plans: [],
                category: "",
                mainMessage: "",
            })
        }
    }

    function isDisabled() {
        return !showExportOption() && !showHcpPageOption() && !showFocusPageOption();
    }

    function showExportOption() {
        return includeExportOption && isExportDataEnabled;
    }

    function showHcpPageOption() {
        return (salesAidGenerationHomePageEnabled || forceShowSalesAidOption) && (salesAidGenerationEnabled && !batchPrintEnabled);
    }

    function showFocusPageOption() {
        return (salesAidGenerationHomePageEnabled || forceShowSalesAidOption) && (salesAidGenerationEnabled && batchPrintEnabled);
    }

    return (
        <>
            {!isDisabled() && (<>
                <ExportReportDataModal
                    show={showExportDataModal}
                    setShow={setShowExportDataModal}
                />
                <Dropdown className='dropdown-menu-end'>
                    <Dropdown.Toggle className='btn btn-primary btn-icon-only'>
                        <span className='fa-regular fa-plus btn-icon'></span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {showExportOption() &&
                            <Dropdown.Item>
                                <Link onClick={handleExportDataModalClick} className='dropdown-item'>
                                    {getConfigValue(appState?.config?.UtilizationDashboard?.Export?.Button?.Label, appState)?.Value === 'true' || "Export data (CSV)"}
                                </Link>
                            </Dropdown.Item>
                        }
                        {showFocusPageOption() &&
                            <Dropdown.Item>
                                <Link onClick={() => setFocus(focusTypeName.HCPs)} to='/FocusPage' className='dropdown-item'>
                                    {getConfigValue(appState?.config?.NavBar?.Menu?.CreateSalesAid?.Label, appState)?.Value || null}
                                </Link>
                            </Dropdown.Item>}
                        {showHcpPageOption() &&
                            <Dropdown.Item>
                                <Link onClick={() => setFocus(focusTypeName.HCPs)} to={isTerritoryStepSkipped(appState, focusTypeName.HCPs) ? "/HCPPage" : "/TerritoryPage"} className='dropdown-item'>
                                    {getConfigValue(appState?.config?.NavBar?.Menu?.CreateSalesAid?.Label, appState)?.Value || null}
                                </Link>
                            </Dropdown.Item>}

                    </Dropdown.Menu>
                </Dropdown>
            </>
            )}
        </>
    );
}

export default PageContextMenu;